import type { VoiceCostSummary, VoiceSessionCostRollup } from '../../client';
import { formatCostTotal } from '../../utils/formatCost';

export type VoiceCostState = 'loading' | 'ready' | 'error';

export interface FormattedVoiceSessionCost {
  audio: string;
}

function formatSummary(
  summary: VoiceCostSummary,
  settlementPending: boolean,
): string {
  if (
    summary.pricingState === 'no_usage' ||
    (summary.metricCount === 0 && summary.totalUsd === null)
  ) {
    if (settlementPending) return 'Calculating cost…';
    return 'No live audio usage';
  }
  if (summary.totalUsd !== null) {
    return `${formatCostTotal(summary.totalUsd)} ${settlementPending ? 'known ' : ''}live audio`;
  }
  if (summary.knownTotalUsd > 0) {
    return `${formatCostTotal(summary.knownTotalUsd)} known live audio + unpriced usage`;
  }
  return 'Unpriced live audio usage';
}

export function formatVoiceSessionCost(
  session: VoiceSessionCostRollup | undefined,
  state: VoiceCostState,
  active = false,
): FormattedVoiceSessionCost {
  if (state === 'error') {
    return { audio: 'Cost unavailable' };
  }
  if (session) {
    return { audio: formatSummary(session.audio, session.settlementPending) };
  }
  if (state === 'loading') {
    return { audio: 'Calculating cost…' };
  }
  return { audio: active ? 'Calculating cost…' : 'No live audio usage' };
}
